import { useEffect } from "react";

const PerformanceMonitor = () => {
  useEffect(() => {
    // Monitor page load performance
    const measurePerformance = () => {
      if (window.performance && window.performance.timing) {
        const timing = window.performance.timing;
        const loadTime = timing.loadEventEnd - timing.navigationStart;
        const domContentLoaded =
          timing.domContentLoadedEventEnd - timing.navigationStart;
        const firstPaint = window.performance
          .getEntriesByType("paint")
          .find((entry) => entry.name === "first-paint");
        const firstContentfulPaint = window.performance
          .getEntriesByType("paint")
          .find((entry) => entry.name === "first-contentful-paint");

        console.log("Performance Metrics:");
        console.log(`Page Load Time: ${loadTime}ms`);
        console.log(`DOM Content Loaded: ${domContentLoaded}ms`);
        if (firstPaint) console.log(`First Paint: ${firstPaint.startTime}ms`);
        if (firstContentfulPaint)
          console.log(
            `First Contentful Paint: ${firstContentfulPaint.startTime}ms`
          );

        // Log to analytics if available
        if (window.gtag) {
          window.gtag("event", "page_load_time", {
            value: loadTime,
            custom_parameter: "portfolio",
          });
        }
      }
    };

    // Measure performance after page load
    if (document.readyState === "complete") {
      measurePerformance();
    } else {
      window.addEventListener("load", measurePerformance);
    }

    // Monitor Core Web Vitals
    const measureWebVitals = () => {
      // Largest Contentful Paint (LCP)
      new PerformanceObserver((entryList) => {
        const entries = entryList.getEntries();
        const lastEntry = entries[entries.length - 1];
        console.log("LCP:", lastEntry.startTime);
      }).observe({ entryTypes: ["largest-contentful-paint"] });

      // First Input Delay (FID)
      new PerformanceObserver((entryList) => {
        const entries = entryList.getEntries();
        entries.forEach((entry) => {
          console.log("FID:", entry.processingStart - entry.startTime);
        });
      }).observe({ entryTypes: ["first-input"] });

      // Cumulative Layout Shift (CLS)
      let clsValue = 0;
      new PerformanceObserver((entryList) => {
        const entries = entryList.getEntries();
        entries.forEach((entry) => {
          if (!entry.hadRecentInput) {
            clsValue += entry.value;
          }
        });
        console.log("CLS:", clsValue);
      }).observe({ entryTypes: ["layout-shift"] });
    };

    // Only run Web Vitals monitoring in production
    if (process.env.NODE_ENV === "production") {
      measureWebVitals();
    }

    return () => {
      window.removeEventListener("load", measurePerformance);
    };
  }, []);

  return null; // This component doesn't render anything
};

export default PerformanceMonitor;
